"use client";

import Link from "next/link";
import { useHasMounted } from "@/hooks/useHasMounted";
import { getDayWindow } from "../_logic/calendar";
import { RISE_HUB_PATH } from "../_logic/constants";
import { RISE_DAYS } from "../_logic/schedule";

/** The banner comes down when the last game closes. */
const LIVE_UNTIL_MS = getDayWindow(RISE_DAYS[RISE_DAYS.length - 1]).closesAt.getTime();

/**
 * Banner on /games pointing to the RISE countdown while it runs. Shown only after mount, so
 * the server render (which can't know the viewer's clock) never flashes a stale banner.
 *
 * @returns The banner, or nothing outside the countdown.
 */
export function RiseGamesBanner() {
  // Hooks
  const hasMounted = useHasMounted();

  // Derived values
  const isLive = hasMounted && Date.now() < LIVE_UNTIL_MS;

  // Render
  if (!isLive) return null;
  return (
    <Link
      href={RISE_HUB_PATH}
      className="mx-auto mb-12 flex max-w-3xl flex-col gap-1 rounded-2xl bg-yellow-50 p-6 transition-colors hover:bg-yellow-100"
    >
      <span className="text-sm font-semibold text-gray-600">⚜️ eaMAFIA × Nowadays</span>
      <span className="text-xl font-bold text-gray-900">RISE countdown games are on →</span>
      <span className="text-sm font-medium text-gray-700">
        A NOLA-themed game every weekday until RISE, with a live leaderboard and prizes.
      </span>
    </Link>
  );
}
